export const pricingSection = {
  kicker: 'Тарифы',
  title: ['Выберите оптимальный', 'формат участия'],
  description: ['Каждый тариф даёт доступ к широким возможностям', 'форума и создан для максимальной пользы'],
  countdown: {
    label: 'До начала форума осталось:',
    startedLabel: 'Форум начался',
    targetDate: '2026-06-18T09:00:00+07:00'
  },
  plans: [
    {
      slug: 'online',
      title: 'Онлайн',
      subtitle: 'Удалённое участие в форуме',
      price: '1 000 ₽',
      features: [
        'Прямая трансляция всех выступлений',
        'Доступ к записям 30 дней после форума',
        'Презентации спикеров',
        'Общий чат участников онлайн',
        'Вопросы спикерам в чате'
      ]
    },
    {
      slug: 'basic',
      title: 'Базовый',
      subtitle: 'В стоимость входит',
      price: '7 000 ₽',
      features: [
        'Доступ ко всем выступлениям',
        'Участие в общей программе',
        'Общий чат участников',
        'Кофе-брейки',
        'Доступ в партнёрскую зону'
      ]
    },
    {
      slug: 'business',
      title: 'Бизнес',
      subtitle: 'Всё из тарифа «Базовый», плюс:',
      price: '12 000 ₽',
      popular: true,
      features: [
        'Первичная консультация бизнес-аналитика',
        'Места ближе к сцене',
        'Приоритетная регистрация (без очередей)',
        'Доступ к материалам форума (презентации)',
        'Выделенный нетворкинг-блок (отдельная сессия для бизнес/VIP)'
      ]
    },
    {
      slug: 'vip',
      title: 'VIP',
      subtitle: 'Всё из тарифа «Бизнес», плюс:',
      price: '20 000 ₽',
      features: [
        'Лучшие места (первые ряды)',
        'Доступ в VIP-зону',
        'Закрытый ужин с участниками и спикерами',
        'Модерируемые знакомства (помощь в установлении полезных контактов)'
      ]
    }
  ],
  actionLabel: 'Выбрать тариф',
  help: {
    text: 'Напишите — подскажем, какой формат подойдёт именно вам.',
    action: {
      label: 'Написать в чат',
      href: 'https://max.ru/u/f9LHodD0cOJ1otgVx9KGa4maaCIVqQH5TX7X3JwN8a8incQQs69OylZpCCU',
      target: '_blank',
      rel: 'noreferrer'
    }
  }
};
